module.exports = __webpack_public_path__ + "img/keychain.28d9cf99.svg";